module.exports = __webpack_public_path__ + "img/logo.2596b180.png";